<div class="surface-card p-4 shadow-2 border-round">
  
<p-tabView styleClass="tabview-custom" (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
  <p-tabPanel >
    <ng-template pTemplate="header" style="color: #0A122A;">
      <div class=" font-semibold font-['Poppins']" >SITUAZIONE AGGIORNATA</div>
    </ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
          <span class="p-input-icon-left mr-2">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="Cerca" (input)="filtraODA($event)" [disabled]="isLoadingResults" />
          </span>
          
          <div class="flex align-items-center ">
            <p-inputSwitch [(ngModel)]="mostraOdaCompletati" (ngModelChange)="onMostraCompletatiChange($event)"></p-inputSwitch>
            <span class="font-['Poppins'] ml-2 text-900">Mostra ODA completati</span>
          </div>
          <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" 
          style="background-color: #809cd4; border-color:#191a1b; color: #f9f9f9;font-size: 13px;" (click)="removeFilter()"
          pTooltip="Rimuovi filtro" tooltipPosition="top" class="ml-2"
        ></button>
      </div>
      <div class="flex justify-end md:justify-center">
<!--         <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">ORDINI DI ACQUISTO</span>
 -->      </div>
      
      <div class="flex justify-end md:justify-end">
       
        <button 
            pButton type="button" icon="pi pi-cloud-download"
            pTooltip="Scarica export" tooltipPosition="top"
            class="font-['Poppins'] mr-3"
            style="background-color:#ffffff; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
            label="Scarica report"
            (click)="scaricaReportBEF()" [disabled]="isLoadingResults"
        ></button>
      </div>

    </div>
 
    <div fxFlex="95%" class="mt-2">
      <ng-template [ngIf]="isLoadingResults">
        <app-loading></app-loading>
      </ng-template>
        <p-table #odaDT styleClass="p-datatable-sm" [loading]="isLoadingResults" [value]="listaODA" dataKey="id" [(selection)]="selectedODA"
        [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
        currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
        [globalFilterFields]="['numero','bando','azienda','importo']"
        >

        <ng-template pTemplate="header">
          <tr>
            <th class="text-center font-['Poppins']" style="font-size: 13px;">Azioni</th>
            <th class="text-center font-['Poppins']"  pSortableColumn="numero" style="font-size: 13px;">
                ODA
            </th>
            <th class="text-center font-['Poppins']" style="font-size: 13px;">
                BANDO
            </th>
            <th class="text-center font-['Poppins']" style="font-size: 13px;">
                IMPRESA
            </th>
            <th class="text-center font-['Poppins']" style="font-size: 12px;">
                VALORE FASE I
            </th>
            <th class="text-center font-['Poppins']" style="font-size: 12px;">
                VALORE FASE II
            </th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">
              VALORE O.E.
          </th>
            <th class="text-center font-['Poppins']" style="font-size: 12px;">
              VALORE FASE III
          </th>
          <th class="text-center font-['Poppins']" style="font-size: 12px;">
            VALORE KO
        </th>
          <th class="text-center font-['Poppins']" style="font-size: 12px;">
              TOTALE DOVUTO
          </th>
            <th class="text-center  font-['Poppins']" style="font-size: 12px;">
                IMPORTO ODA
            </th>
            
            <th class="text-center  font-['Poppins']" style="font-size: 12px;">
                IMPORTO EM
            </th>
            <th class="text-center  font-['Poppins']" style="font-size: 12px;">
                  RESIDUO 
            </th>
              <th class="text-center font-['Poppins']" style="font-size: 12px;">
                ULTIMO MDP
          </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
            <tr>
              <td class="text-center" style="width: 10px;">
                <button 
                  pButton type="button" style="color:rgb(39, 128, 15)"
                  icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text" 
                  (click)="openCaricaAzioniOda($event,row)">
                </button> 
              </td>
              <td class="text-center"> 
                <p-tag [value]="row.numero "
                      [style]="{
                        'background-color': '#78C0E0' ,
                        'color': '#ffffff' ,
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '700',
                        'font-size': '12px',
                        'letter-spacing': '.3px;',
                       
                      }"
                  
                          
                ></p-tag>
              
              </td>
              <td class="text-center font-['Poppins']">   
                <p-tag
                      [value]="row.bando | uppercase"
                      [style]="{
                        'background-color': row.bando==='BANDO 1'?'cadetblue':'cornflowerblue' ,
                        'color': '#ffffff' ,
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '700',
                        'font-size': '10px',
                        'letter-spacing': '.3px;',
                        'cursor': 'pointer',
                      }"
                       class="mr-1"
                       (click)="filtraPerBando(row)"
                       [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per '+row.numero"
                       tooltipPosition="top"
                  ></p-tag>
               </td>
              <td class="text-center font-['Poppins']"> 
                <p-tag
                        [value]="row.azienda | uppercase"
                        [style]="{
                          'background-color': '#326F6F' ,
                          'color': '#ffffff' ,
                          'border-radius': '6px',
                          'padding': '.25em .5rem',
                          'font-weight': '700',
                          'font-size': '10px',
                          'letter-spacing': '.3px;',
                          'cursor': 'pointer',
                        }"
                        class="mr-1"
                        (click)="filtraPerAzienda(row)"
                        [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per impresa '+row.numero"
                        tooltipPosition="top"
                    ></p-tag>
                </td>
                <td class="text-center font-['Poppins']"> 
                  <span class="text-uppercase" style="font-size: 12px; ">{{row.importoDovutoFase1 | formattaNumero}} </span> 
                </td>
                <td class="text-center font-['Poppins']"> 
                  <span class="text-uppercase" style="font-size: 12px; ">{{row.importoDovutoFase2 | formattaNumero}}</span> 
                </td>
                <td class="text-center font-['Poppins']"> 
                  <span class="text-uppercase" style="font-size: 12px; ">{{row.importoDovutoOpereExtra | formattaNumero}}</span> 
                </td>
                <td class="text-center font-['Poppins']"> 
                  <span class="text-uppercase" style="font-size: 12px;">{{row.importoDovutoFase3 | formattaNumero}}</span> 
                </td>
                <td class="text-center font-['Poppins']"> 
                  <span class="text-uppercase" style="font-size: 12px; ">{{row.importoDovutoKO | formattaNumero}}</span> 
                </td>
                <td class="text-center font-['Poppins']"> 
                    <span class="text-uppercase font-bold" style="font-size: 13px;">{{(row.importoDovutoFase1 + row.importoDovutoFase2 + row.importoDovutoOpereExtra +row.importoDovutoFase3 + row.importoDovutoKO) | formattaNumero}}</span> 
                </td>
                <td class="text-center font-['Poppins'] font-bold"> <span class="text-uppercase font-semibold" style="font-size: 12px; ">{{row.importo| formattaNumero}}</span> </td>
                <td class="text-center font-['Poppins'] font-bold"> <span class="text-uppercase font-semibold" style="font-size: 12px;">{{row.importoEmEmesse| formattaNumero}}</span> </td>
                <td class="text-center font-['Poppins'] font-bold"> <span class="text-uppercase" style="font-size: 12px; font-weight: bold;" [style]="{'color':row.importoResiduo<=10?'red':'green'}">{{row.importoResiduo| formattaNumero}}</span> </td>
                <td class="text-center font-['Poppins'] "> <span class="text-uppercase" style="font-size: 12px;">{{row.dataUltimoMdp?utilService.formattaDataDaTimestampFirestore(row.dataUltimoMdp):''}}</span> </td>

              
              </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr >
              <td colspan="4" class="text-right" style="font-size: 14px ; font-weight: bold;">TOTALI:</td>
               <td class="text-center font-['Poppins']" style="font-size: 14px ; font-weight: bold;">{{importoTotaleFase1 | formattaNumero}} €</td>
               <td class="text-center font-['Poppins']" style="font-size: 14px ; font-weight: bold;">{{importoTotaleFase2 | formattaNumero}} €</td>
               <td class="text-center font-['Poppins']" style="font-size: 14px ; font-weight: bold;">{{importoTotaleOpereExtra | formattaNumero}} €</td>
               <td class="text-center font-['Poppins']" style="font-size: 14px ; font-weight: bold;">{{importoTotaleFase3 | formattaNumero}} €</td>
               <td class="text-center font-['Poppins']" style="font-size: 14px ; font-weight: bold;">{{importoTotaleKO | formattaNumero}} €</td>
               <td class="text-center font-['Poppins']" style="font-size: 14px ; font-weight: bold;">{{importoTotaleDovuto | formattaNumero}} €</td>
               <td ></td>
               <td ></td>
               <td ></td>
               <td ></td>
          </tr>
        </ng-template>
      </p-table>
      <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
    </div>


  </p-tabPanel>
  <p-tabPanel >
    <ng-template pTemplate="header" style="color: #0A122A;">
      <div class=" font-semibold font-['Poppins']" >MANDATI DI PAGAMENTO</div>
    </ng-template>
    <ng-template [ngIf]="isLoadingResults">
      <app-loading></app-loading>
    </ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
          <span class="p-input-icon-left mr-2">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="Cerca" (input)="filtraMDP($event)" [disabled]="isLoadingResults" />
          </span>
          <button pButton type="button" icon="pi pi-refresh" 
          style="background-color: #6797a3; border-color:#093139; color: #f9f9f9;font-size: 13px;" (click)="loadMandatiDiPagamento()"
          pTooltip="Aggiorna dati" tooltipPosition="top" 
          ></button>
       </div>
      
      <div class="flex justify-end md:justify-center">
<!--         <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">MANDATI DI PAGAMENTO</span>
 -->      </div>
      
      <div class="flex justify-end md:justify-end">
       <!--  <button 
          pButton type="button" icon="pi pi-plus" 
          pTooltip="Crea Mandato di pagamento" tooltipPosition="top" 
          class="font-['Poppins']"
          style="background-color:cadetblue; color: rgb(22, 37, 38); border-color: cadetblue; font-size: 13px;"
          label="Nuovo"
          (click)="openCreaMandatoDiPagamentoDialog()" 
          [disabled]="isLoadingResults">
       </button> -->
      </div>

    </div>

    <div fxFlex="95%" class="mt-2">
      
      <p-table #mdpDT styleClass="p-datatable-sm" [loading]="isLoadingResults" [value]="listaMdP" dataKey="id" [(selection)]="selectedMdp"
      [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
      currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
      [globalFilterFields]="['numero','entrataDiMagazzino.codice','bando','oda.azienda.ragioneSociale','importo','oda.numero']"
      >

      <ng-template pTemplate="header">
        <tr>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">Azioni</th>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">
            CODICE EM
        </th>
        <th class="text-center font-['Poppins']" style="font-size: 13px;">
            STATO
        </th>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">
              ODA
          </th>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">
              IMPRESA
          </th>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">
              DATA CREAZIONE
          </th>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">
              DATA EMISSIONE EM
          </th>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">
            PERIODO RIFERIMENTO
        </th>
        <th class="text-right font-['Poppins']" style="font-size: 13px;">
            TOTALE DOVUTO
        </th>
          <th class="text-center font-['Poppins']" style="font-size: 13px;">
              VALORE
          </th>
          
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
          <tr>
            <td class="text-center" style="width: 10px;">
              <button 
                pButton type="button" style="color:rgb(39, 128, 15)"
                icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text" 
                (click)="openCaricaAzioniMdp($event,row)">
              </button> 
            </td>
            <td class="text-center"> 
              <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 13px;">{{row.entrataDiMagazzino?row.entrataDiMagazzino.codice:''}}</span> 
            </td>
            <td class="text-center"> 
              <p-tag
                      [value]="row.entrataDiMagazzino?'EM EMESSA':'IN ATTESA DI EM' | uppercase"
                      [style]="{
                        'background-color': row.entrataDiMagazzino?'#1E555C':'#EDB183' ,
                        'color': '#ffffff' ,
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '700',
                        'font-size': '13px',
                        'letter-spacing': '.3px;',
                       
                      }"
                  ></p-tag>
                    </td>
            <td class="text-center font-['Poppins']"> 
              <p-tag
                      [value]="row.oda.numero "
                      [style]="{
                        'background-color': '#88CCF1' ,
                        'color': '#ffffff' ,
                        'border-radius': '6px',
                        'padding': '.25em .5rem',
                        'font-weight': '700',
                        'font-size': '13px',
                        'letter-spacing': '.3px;',
                        'cursor': 'pointer',
                      }"
                      [pTooltip]="'Apri ODA '+ row.oda.numero"  tooltipPosition="top"
                  ></p-tag>
              </td>
              <td class="text-center font-['Poppins']"> 
                <p-tag
                [value]="row.oda.azienda.ragioneSociale | uppercase"
                [style]="{
                  'background-color': '#326F6F' ,
                  'color': '#ffffff' ,
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer',
                }"
            ></p-tag> </td>
              <td class="text-center font-['Poppins']"> 
                <span class="text-uppercase font-bold" style="font-size: 13px;">
                  {{utilService.formattaDataDaDate(row.creato)}}
                </span>
              </td>
                
              <td class="text-center font-['Poppins']" > 
                <span class="text-uppercase font-bold" style="font-size: 13px;">
                  {{row.entrataDiMagazzino?utilService.formattaDataDaDate(row.entrataDiMagazzino.dataEmissione):''}}
                </span> 
              </td>
              <td class="text-center font-['Poppins']"> 
                <span class="text-uppercase" style="font-size: 12px;"  >{{utilService.formattaDataDaDate(row.inizioPeriodoRiferimento)}}-{{utilService.formattaDataDaDate(row.finePeriodoRiferimento)}}</span> 
              </td>
              <td class="text-right font-['Poppins']"> 
                <span class="text-uppercase font-semibold" style="font-size: 13px;">{{row.valore | formattaNumero}} €</span> 
              </td>
              <td class="text-right font-['Poppins']"> 
                <span class="text-uppercase font-bold" style="font-size: 13px;" 
                [style]="{
                  'color': row.entrataDiMagazzino?row.entrataDiMagazzino.valore===row.valore?'green':'red':'' ,
                }"
                >{{row.entrataDiMagazzino?(row.entrataDiMagazzino.valore | formattaNumero) +' €':''}}</span> 
              </td>
            
            </tr>
      </ng-template>
    </p-table>
    <p-tieredMenu #menuAzioniMdPTiered [popup]="true" [model]="menuAzioniMdPItems"></p-tieredMenu>
  </div>
</p-tabPanel>
</p-tabView>
<p-dialog [(visible)]="showAnnullaMdPConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
    <span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
        <i class="pi pi-trash text-5xl"></i>
    </span>
    <div class="font-medium text-2xl text-900">ELIMINAZIONE MANDATO DI PAGAMENTO</div>
</div>
<p class="line-height-3 p-0 m-0">
   Confermi di voler eliminare il mandato di pagamento per l'oda <span style="font-weight: bold;">{{selectedMdp?selectedMdp.oda.numero:''}}</span> ?
</p>
<ng-template pTemplate="footer">
    <div class=" border-top-1 surface-border pt-3 flex">
        <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showAnnullaMdPConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
        <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaAnnullamentoMdp(true)" label="CONFERMA" class="w-6 ml-2"></button>
    </div>
</ng-template>
</p-dialog> 
<p-toast position="top-center"></p-toast>
